import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, of, tap, throwError } from 'rxjs';
import { MenuItem } from './menu.model';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})

export class MenuService {
  private readonly menuCacheKey = 'menuCache';
  private readonly cacheExpiryDuration = 24 * 60 * 60 * 1000; // 1 day
  private menuSubject = new BehaviorSubject<MenuItem[] | null>(null);
  public menu$: Observable<MenuItem[] | null> = this.menuSubject.asObservable();
  private cachedMenu: MenuItem[] | null = null;
  constructor(private http: HttpClient, public translate: TranslateService) {}
  clearMenuCache(): void {
    localStorage.removeItem(this.menuCacheKey); // Clear the cached menu
  }


   /**
   * Load the dynamic menu for a given role from the backend.
   * Cache it so we only fetch once per user session.
   */
   loadMenuForRole(): Observable<MenuItem[]> {
      return this.http.get<MenuItem[]>(`${environment.apiUrl}/menu`);
  }

  /**
   * Return the current menu (BehaviorSubject), if you want lazy subscription:
   * e.g. in the Sidebar, do `menuService.menu$.subscribe(...)`
   */
  getMenu$(): Observable<MenuItem[] | null> {
    return this.menu$;
  }
}